import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  EffectCoverflow,
  Keyboard,
} from "swiper/modules";
import {
  NewsImage1,
  NewsImage2,
  NewsImage3,
  NewsImage4,
  NewsImage5,
} from "../../assets/Images";

import { Container } from "react-bootstrap";
import "./News.css";

const newsData = [
  {
    day: "12",
    month: "Dec",
    title: "WebZova launches advanced Web Development suite for 2025",
    type: "Web Development",
    excerpt:
      "Our new development suite introduces high-performance React apps, ....", // optimized APIs, and visuallyimmersive UI/UX systems for modern businesses
    image: NewsImage1,
    slug: "webzova-webdev-suite-2025",
  },
  {
    day: "05",
    month: "Dec",
    title: "WebZova partners with local businesses to build digital presence",
    type: "Business",
    excerpt:
      "We successfully onboarded multiple MSMEs to create websites, branding, and automation systems tailored to business growth.",
    image: NewsImage2,
    slug: "webzova-partners-local-business",
  },
  {
    day: "30",
    month: "Nov",
    title: "New AI-powered website performance analyzer introduced",
    type: "AI Tools",
    excerpt:
      "WebZova introduces an AI tool that monitors website speed, SEO, and UX to deliver real-time optimization suggestions.",
    image: NewsImage3,
    slug: "webzova-ai-performance-tool",
  },
  {
    day: "22",
    month: "Nov",
    title: "E-commerce platform built for Berwal Industries Fasteners",
    type: "Case Study",
    excerpt:
      "A fast, secure, and automated product catalog with inquiry management designed for Berwal Industries.",
    image: NewsImage4,
    slug: "berwal-industries-ecommerce-platform",
  },
  {
    day: "16",
    month: "Nov",
    title: "WebZova automation tools cut client workload by 40%",
    type: "Engineering",
    excerpt:
      "Our internal workflow automations improved project management, deployment cycles, and client delivery efficiency.",
    image: NewsImage5,
    slug: "webzova-automation-efficiency",
  },
];

const News = () => {
  const bgRef = useRef(null);
  const swiperRef = useRef(null);
  const newsItemRefs = useRef([]);
  newsItemRefs.current = [];

  const [activeIndex, setActiveIndex] = useState(0);

  const updateBgPosition = (index) => {
    const newsItem = newsItemRefs.current[index];
    if (!newsItem || !bgRef.current) return;

    const slide = newsItem.closest(".swiper-slide");
    if (!slide) return;

    const { left: x, top: y, width, height } = newsItem.getBoundingClientRect();
    bgRef.current.style.width = `${width}px`;
    bgRef.current.style.height = `${height}px`;
    bgRef.current.style.transform = `translateX(${x}px) translateY(${y}px)`;
    bgRef.current.classList.add("active");
  };

  useEffect(() => {
    if (window.innerWidth > 800) {
      const handleHover = (e) => {
        const item = e.currentTarget;
        newsItemRefs.current.forEach((el) => el?.classList.remove("active"));
        item.classList.add("active");

        updateBgPosition(newsItemRefs.current.indexOf(item));
      };

      newsItemRefs.current.forEach((item) => {
        item?.addEventListener("mouseenter", handleHover);
        item?.addEventListener("mouseleave", () => {
          item.classList.remove("active");
          if (bgRef.current) bgRef.current.classList.remove("active");
        });
      });

      return () => {
        newsItemRefs.current.forEach((item) => {
          item?.removeEventListener("mouseenter", handleHover);
          item?.removeEventListener("mouseleave", () => {});
        });
      };
    }
  }, [activeIndex]);

  useEffect(() => {
    // reposition on slide index change (initial, programmatic)
    updateBgPosition(activeIndex);
  }, [activeIndex]);

  useEffect(() => {
    const handleResize = () => updateBgPosition(activeIndex);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [activeIndex]);

  return (
    <section id="newsss">
      <Container>
        <h2 className="news-title text-center">Insights &amp; Case Studies</h2>
        <p className="news-subtitle">
          Real projects, quick updates, and lessons we’ve learned while building
          digital products at WebZova.
        </p>
        <div className="wrapper">
          <div className="item-bg" ref={bgRef}></div>
          <Swiper
            style={{ paddingBottom: "3%" }}
            modules={[Navigation, Pagination, EffectCoverflow, Keyboard]}
            className="news-slider"
            effect="coverflow"
            grabCursor={true}
            // loop={true}
            centeredSlides={true}
            keyboard={{ enabled: true }}
            slidesPerView="auto"
            spaceBetween={0}
            speed={300}
            navigation={{
              nextEl: ".news-slider-next",
              prevEl: ".news-slider-prev",
            }}
            pagination={{ el: ".news-slider__pagination", clickable: true }}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 0,
              modifier: 3,
              slideShadows: false,
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            onSlideChangeTransitionEnd={(swiper) => {
              setTimeout(() => {
                updateBgPosition(swiper.realIndex);
              }, 50); // small delay allows DOM to settle
            }}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
              updateBgPosition(swiper.realIndex);
            }}
          >
            {newsData.map((item, idx) => (
              <SwiperSlide className="news-slider__item" key={item.slug}>
                <a
                  className="news__item"
                  aria-label={item.title}
                  ref={(el) => el && (newsItemRefs.current[idx] = el)}
                >
                  <div className="news-date">
                    <span className="news-date__title">{item.day}</span>
                    <span className="news-date__txt">{item.month}</span>
                  </div>

                  <div className="news__title">{item.title}</div>
                  <p className="news__txt">{item.excerpt}</p>

                  <div className="news__img">
                    <img src={item.image} alt={item.title} loading="lazy" />
                  </div>
                </a>
              </SwiperSlide>
            ))}

            <div className="news-slider__ctr">
              <div className="news-slider__arrows">
                <button className="news-slider__arrow news-slider-prev">
                  <span className="icon-font">
                    <svg className="icon icon-arrow-left">
                      <use xlinkHref="#icon-arrow-left"></use>
                    </svg>
                  </span>
                </button>
                <button className="news-slider__arrow news-slider-next">
                  <span className="icon-font">
                    <svg className="icon icon-arrow-right">
                      <use xlinkHref="#icon-arrow-right"></use>
                    </svg>
                  </span>
                </button>
              </div>
              <div className="news-slider__pagination"></div>
            </div>
          </Swiper>
        </div>
      </Container>

      <svg hidden="hidden">
        <defs>
          <symbol id="icon-arrow-left" viewBox="0 0 32 32">
            <title>arrow-left</title>
            <path d="M0.704 17.696l9.856 9.856c0.896 0.896 2.432 0.896 3.328 0s0.896-2.432 0-3.328l-5.792-5.856h21.568c1.312 0 2.368-1.056 2.368-2.368s-1.056-2.368-2.368-2.368h-21.568l5.824-5.824c0.896-0.896 0.896-2.432 0-3.328-0.48-0.48-1.088-0.704-1.696-0.704s-1.216 0.224-1.696 0.704l-9.824 9.824c-0.448 0.448-0.704 1.056-0.704 1.696s0.224 1.248 0.704 1.696z" />
          </symbol>
          <symbol id="icon-arrow-right" viewBox="0 0 32 32">
            <title>arrow-right</title>
            <path d="M31.296 14.336l-9.888-9.888c-0.896-0.896-2.432-0.896-3.328 0s-0.896 2.432 0 3.328l5.824 5.856h-21.536c-1.312 0-2.368 1.056-2.368 2.368s1.056 2.368 2.368 2.368h21.568l-5.856 5.824c-0.896 0.896-0.896 2.432 0 3.328 0.48 0.48 1.088 0.704 1.696 0.704s1.216-0.224 1.696-0.704l9.824-9.824c0.448-0.448 0.704-1.056 0.704-1.696s-0.224-1.248-0.704-1.664z" />
          </symbol>
        </defs>
      </svg>
    </section>
  );
};

export default News;
